module.exports = __webpack_public_path__ + "static/media/BharatSandesh.06a28dad.png";